
/**
 * SS Calendly: Popup + Meta Lead + Attribution
 * - Adds fbclid/_fbp/fbc to ALL calendly links (same-page only)
 * - Fires Lead ONLY on Eigenmarken Landing AND only for the Eigenmarken Calendly booking URL
 * - Keeps popup=true behavior (opens Calendly popup)
 */
(function () {
  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  function getLocal(key) {
    try { return localStorage.getItem(key) || ''; } catch(e) { return ''; }
  }

  function isCalendlyUrl(url) {
    return /(^|\/\/)(www\.)?calendly\.com\//i.test(url || '');
  }

  function isEigenmarkenLanding() {
    return document.body && document.body.classList && document.body.classList.contains('ss-landing--eigenmarken');
  }

  function isEigenmarkenCalendly(urlStr) {
    try {
      var u = new URL(urlStr, window.location.origin);
      var s = u.toString();
      return s.indexOf('calendly.com/kontakt-schneider-solutions/eigenmarken-system-analysegesprach') !== -1;
    } catch(e) {
      return (urlStr || '').indexOf('calendly.com/kontakt-schneider-solutions/eigenmarken-system-analysegesprach') !== -1;
    }
  }

  function ensureAttribution(rawUrl) {
  var fbclid = getLocal('ss_fbclid');
  var fbp    = getCookie('_fbp') || getLocal('ss_fbp');
  var fbc    = (function(){
    var c = getCookie('_fbc');
    if (c) { try { return decodeURIComponent(c); } catch(e) { return c; } }
    return getLocal('ss_fbc');
  })();

  var u;
  try { 
    u = new URL(rawUrl, window.location.origin); 
  } catch(e) { 
    return rawUrl; 
  }

  if (!isCalendlyUrl(u.toString())) return rawUrl;

  // --- Original Meta Parameter ---
  if (fbclid) u.searchParams.set('fbclid', fbclid);
  if (fbp)    u.searchParams.set('_fbp', fbp);
  if (fbc)    u.searchParams.set('fbc', fbc);

  // --- UTM Transport für Zapier / Odoo ---
  if (fbclid) u.searchParams.set('utm_term', fbclid);
  if (fbc)    u.searchParams.set('utm_content', fbc);
  if (fbp)    u.searchParams.set('utm_id', fbp);

  u.searchParams.set('utm_source', 'meta');
  u.searchParams.set('utm_medium', 'paid');
  u.searchParams.set('utm_campaign', 'eigenmarken-system');

  return u.toString();
}

  function stripPopupParam(urlStr) {
    var u;
    try { u = new URL(urlStr, window.location.origin); } catch(e) { return urlStr; }
    u.searchParams.delete('popup');
    return u.toString();
  }

  function fireLead() {
    if (typeof fbq !== 'undefined') {
      try { fbq('track', 'Lead'); } catch(e) {}
    }
  }

  document.addEventListener('click', function (event) {
    var a = event.target && event.target.closest ? event.target.closest('a') : null;
    if (!a) return;

    var href = a.getAttribute('href');
    if (!href) return;

    if (!isCalendlyUrl(href)) return;

    // Always add attribution (so Calendly -> Zapier -> Odoo can carry it)
    var withParams = ensureAttribution(href);

    // Detect popup=true
    var hasPopup = /(^|[?&])popup=true([&#]|$)/i.test(withParams);

    // Fire Lead ONLY on Eigenmarken Landing + ONLY for the specific Eigenmarken Calendly URL
    if (isEigenmarkenLanding() && isEigenmarkenCalendly(withParams)) {
      fireLead();
    }

    if (hasPopup) {
      event.preventDefault();
      var popupUrl = stripPopupParam(withParams);
      setTimeout(function () {
        Calendly.initPopupWidget({ url: popupUrl });
      }, 250);
      return;
    }

    // Normal Calendly links: rewrite and allow navigation
    a.setAttribute('href', withParams);
  }, true);
})();


  function closeCalendlyPopup() {
    if (typeof Calendly !== 'undefined' && Calendly.closePopupWidget) {
      Calendly.closePopupWidget();
    }
  }

  // Optional: Schließe das Popup auch, wenn der ESC-Key gedrückt wird
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      closeCalendlyPopup();
    }
  });


  // Beobachtet das Dokument, um zu erkennen, wann Calendly das Overlay einfügt
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1 && node.classList && node.classList.contains('calendly-popup-overlay')) {
          // Wenn ein Overlay gefunden wurde, binde einen touchstart-Listener (für mobile Geräte)
          node.addEventListener('touchstart', function() {
            if (typeof Calendly !== 'undefined' && Calendly.closePopupWidget) {
              Calendly.closePopupWidget();
            }
          });
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });


  document.addEventListener('DOMContentLoaded', function() {
    const serviceModal = document.getElementById('vertrag-modal');
    const serviceLanguage = (document.documentElement.lang || 'de').split('-')[0];
    const serviceCopy = {
      en: {
        before: 'Please confirm that you have read and agree to our ',
        link: 'service agreement (in German)',
        after: '.',
        agree: 'I agree',
        add: 'Add to cart',
        cancel: 'Cancel'
      },
      fr: {
        before: 'Veuillez confirmer que vous avez lu et acceptez notre ',
        link: 'contrat de prestation (en allemand)',
        after: '.',
        agree: 'J’accepte',
        add: 'Ajouter au panier',
        cancel: 'Annuler'
      }
    }[serviceLanguage];
    if (serviceModal && serviceCopy) {
      const paragraph = serviceModal.querySelector('p');
      const agreement = paragraph && paragraph.querySelector('a');
      if (paragraph && agreement) {
        agreement.textContent = serviceCopy.link;
        paragraph.replaceChildren(document.createTextNode(serviceCopy.before), agreement, document.createTextNode(serviceCopy.after));
      }
      const label = serviceModal.querySelector('label');
      if (label && label.lastChild) label.lastChild.textContent = ' ' + serviceCopy.agree;
      const buttons = serviceModal.querySelectorAll('button');
      if (buttons[0]) buttons[0].textContent = serviceCopy.add;
      if (buttons[1]) buttons[1].textContent = serviceCopy.cancel;
    }
    const serviceButtons = document.querySelectorAll('.add-to-cart-service');

    serviceButtons.forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        window.productToAdd = btn.getAttribute('data-variant-id');
        document.getElementById('vertrag-modal').style.display = 'block';
      });
    });

    document.getElementById('vertrag-bestätigen').addEventListener('click', function() {
      if (document.getElementById('vertrag-check').checked) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ quantity: 1, id: window.productToAdd })
        })
        .then(() => window.location.href = '/cart');
      } else {
        alert(globalThis.SSUiText('Bitte bestätige den Vertrag, bevor du fortfährst.'));
      }
    });
  });


(function () {
  var started = false;
  var timer;
  var events = ['pointerdown', 'keydown', 'scroll'];
  function appendScript(url) {
    return new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = url;
      script.async = true;
      script.dataset.ssLivechat = 'true';
      script.onload = resolve;
      script.onerror = reject;
      document.body.appendChild(script);
    });
  }
  function start() {
    if (started) return;
    started = true;
    window.clearTimeout(timer);
    events.forEach(function (name) { window.removeEventListener(name, start); });
    appendScript('https://schneider-solutions.odoo.com/im_livechat/loader/1')
      .then(function () { return appendScript('https://schneider-solutions.odoo.com/im_livechat/assets_embed.js'); })
      .catch(function () { started = false; });
  }
  events.forEach(function (name) { window.addEventListener(name, start, { passive: true }); });
  timer = window.setTimeout(start, 8000);
})();



